import React, { Component } from 'react';
import { Footer } from 'grainger-component-library';

import Navigation from '../Navigation/Navigation';
import { getGlobal, getLeasingAPI, getAPI } from '../../utils/cms';
import prismicHelpers from '../../utils/prismicHelpers';

export const PageTemplate = (WrappedPage, options = {}) => {
  return class extends Component {
    constructor(props) {
      super(props);

      const globalItems = this.parseSessionStorage();
      const documents = this.parseSessionStorage();

      this.state = {
        api: null,
        ...globalItems,
        ...documents,
      }
    }

    parseSessionStorage() {
      let items = {}
      for(let key in window.sessionStorage) {
        if (!window.sessionStorage.hasOwnProperty(key)) continue;
        items[key] = JSON.parse(window.sessionStorage[key]);
      }
      return items;
    }

    putGlobalItemsInSessionStorage(globalData) {
      for (var key in globalData) {
        if (!globalData.hasOwnProperty(key)) continue;
        window.sessionStorage.setItem(key, JSON.stringify(globalData[key]));
      }
      return globalData;
    }

    componentDidMount() {
      getLeasingAPI()
        .then((api) => {
          return getGlobal(api, ['documents'])
            .then(this.putGlobalItemsInSessionStorage)
            .then(documents => ({
              api,
              ...documents
            }));
        })
        .then(response => this.setState({ ...response }))
        .catch(e =>
          this.setState({
            error: `Cannot contact the API, check your prismic configuration:\n${e}`
          }));

      getAPI()
        .then((api) => {
          return getGlobal(api, ['footer'])
            .then(this.putGlobalItemsInSessionStorage)
            .then(globalItems => ({
              api,
              ...globalItems
            }));
        })
        .then(response => this.setState({ ...response }))
        .catch(e =>
          this.setState({
            error: `Cannot contact the API, check your prismic configuration:\n${e}`
          }));
    }

    componentDidUpdate() {
      this.refreshToolbar();
    }

    refreshToolbar() {
      // Start an experiment if there is one
      // const maybeCurrentExperiment = this.state.api.currentExperiment()
      // if (maybeCurrentExperiment) {
      //   window.PrismicToolbar.startExperiment(maybeCurrentExperiment.googleId())
      // }
      // // Launch the prismic.io toolbar
      // window.PrismicToolbar.setup('https://graingerplc.cdn.prismic.io/api/v2');
    }

    render() {
      return (
        <React.Fragment>
          <Navigation navLinks={prismicHelpers.documents(this.state.leasing_documents && this.state.leasing_documents.documents)} />

          <WrappedPage {...this.state} />

          {this.state.footer &&
            <Footer
              showFeed={prismicHelpers.yesNo(this.state.footer.show_feed)}
              pages={prismicHelpers.footerPages(this.state.footer.pages)}
              social={prismicHelpers.footerSocial(this.state.footer.social_links)}
              text={prismicHelpers.plainText(this.state.footer.text)}
              phone={prismicHelpers.plainText(this.state.footer.phone_number)}
              graingerInfo={prismicHelpers.plainText(this.state.footer.grainger_info)}
              env={'production'}
            />}
        </React.Fragment>
      )
    }
  }
};

export default PageTemplate;



// WEBPACK FOOTER //
// ./src/components/PageTemplate/PageTemplate.jsx